import { Box, Button, Grid, LinearProgress, Typography } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import { useSnackbar } from "../contexts/SnackbarProvider";
import ShowItem from "../components/ShowItem/ShowItem";
import DeleteDialog from "../components/DeleteDialog";
import { useAuth } from "../contexts/AuthContext";
import { useAsync } from "../utils/useAsync";
import { apiCall } from "../utils/apiCall";
import CUUnit from "./CUUnit";
import TopSection from "../components/TopSection";
import { filterItems } from "../utils/filterItem";
import useIsSmallScreen from "../utils/useIsSmallScreen";

const UnitsOfBook = () => {
  const IS_SMALL_SCREEN = useIsSmallScreen();

  const Auth = useAuth();
  let { bookId } = useParams();
  const navigate = useNavigate();
  const { setSnackbarDetail } = useSnackbar();
  const [actionType, setActionType] = useState("");
  const [selectedUnit, setSelectedUnit] = useState();
  const [refetchUnits, setRefetchUnits] = useState(1);

  const [searchText, setSearchText] = useState("");

  const {
    run: getNumberOfButtons,
    data: numberOfButtons,
    isLoading: isLoadingNumberOfButtons,
  } = useAsync({});

  useEffect(() => {
    getNumberOfButtons(
      apiCall({ entity: `api/count/bookAudio/${bookId}`, method: "get" })
    );
  }, [bookId, getNumberOfButtons]);

  const {
    run: getBook,
    data: book,
    isLoading: isLoadingbook,
  } = useAsync({ units: [] });

  useEffect(() => {
    getBook(apiCall({ entity: `api/books/${bookId}`, method: "get" }));
  }, [bookId, getBook]);

  const {
    run: getAllUnits,
    data: allUnits,
    status: allUnitsStatus,
    isLoading: isLoadingUnits,
  } = useAsync({ units: [] });

  useEffect(() => {
    getAllUnits(
      apiCall({ entity: `api/unit?bookId=${bookId}`, method: "get" })
    );
  }, [bookId, getAllUnits, refetchUnits]);

  async function deleteUnit() {
    Auth.AuthenticatedServerCall({
      method: "DELETE",
      entity: `api/units/${selectedUnit.id}`,
    })
      .then((res) => {
        setSnackbarDetail({
          open: true,
          message: res.message,
          severity: "success",
        });
        setRefetchUnits((i) => i + 1);
      })
      .catch((error) => {
        setSnackbarDetail({
          open: true,
          message: error.message,
          severity: "error",
        });
      });
    setActionType();
    setSelectedUnit();
  }

  if (actionType === "create") {
    return (
      <CUUnit
        onBack={(refresh) => {
          setActionType();
          if (refresh) {
            setRefetchUnits((prev) => prev + 1);
          }
        }}
        bookId={bookId}
      />
    );
  }

  if (actionType === "edit") {
    return (
      <CUUnit
        onBack={(refresh) => {
          setActionType(false);
          if (refresh) {
            setRefetchUnits((prev) => prev + 1);
          }
        }}
        bookId={bookId}
        unit={selectedUnit}
      />
    );
  }
  return (
    <Box className="md-unitsOfBook">
      <DeleteDialog
        open={actionType === "delete"}
        onClose={() => {
          setActionType();
          setSelectedUnit();
        }}
        onDelete={deleteUnit}
        title={`Are you sure to delete ${selectedUnit?.title} unit?`}
      />

      <TopSection
        title="Live The Language!"
        searchText={searchText}
        setSearchText={setSearchText}
        numberOfBooks={allUnits?.units?.length}
        numberOfVoices={numberOfButtons?.book_audio_count}
        cover={`${process.env.REACT_APP_END_POINT}assets/title/books/book${
          IS_SMALL_SCREEN ? "-mobile" : ""
        }-${bookId}.jpg`}
        onBack={() => navigate("/")}
      />

      {isLoadingUnits || isLoadingbook ? (
        <LinearProgress />
      ) : allUnitsStatus === "resolved" && allUnits ? (
        <>
          {Auth.loggedInUser?.id && (
            <Button variant="contained" onClick={() => setActionType("create")}>
              Add new Unit
            </Button>
          )}
          <Grid
            container
            rowSpacing={1}
            columnSpacing={1}
            className="topSection"
            alignItems="stretch"
          >
            <Grid item xs={12} md={1} className="center-item"></Grid>
            <Grid item xs={12} md={10} sx={{ display: "block", marginTop: 2 }}>
              <Typography variant="h4" sx={{ mt: 4, mb: 2 }} color="primay">
                {book?.book?.title}
              </Typography>
              <Grid
                className="md-unitsOfBooksList md-GridListContainer"
                container
                item
                rowSpacing={2}
                columnSpacing={2}
                alignItems="stretch"
                sx={{
                  justifyContent: "left",
                  pl: "0px",
                  pr: 0,
                }}
              >
                {allUnits?.units
                  ?.filter((unit) => filterItems(unit, searchText))
                  ?.map((unit) => (
                    <Grid
                      item
                      key={unit.id}
                      xs={6}
                      md={3}
                      sx={{ width: "100%" }}
                      className="md-gridShowItem"
                    >
                      <ShowItem
                        title={unit?.title}
                        imageUrl={unit.image_url}
                        bgColor={unit.bgColor}
                        onClick={() => navigate(`/units/${unit.id}`)}
                        onEdit={
                          Auth.loggedInUser?.id
                            ? () => {
                                setSelectedUnit(unit);
                                setActionType("edit");
                              }
                            : undefined
                        }
                        onDelete={
                          Auth.loggedInUser?.id
                            ? () => {
                                setSelectedUnit(unit);
                                setActionType("delete");
                              }
                            : undefined
                        }
                      />
                    </Grid>
                  ))}
              </Grid>
            </Grid>
            <Grid item xs={12} md={1} className="center-item"></Grid>
          </Grid>
        </>
      ) : (
        <Typography variant="h6">Error on fetching data</Typography>
      )}
    </Box>
  );
};

export default UnitsOfBook;
